const viewModules = import.meta.glob([
  '/src/layouts/**/*.vue',
  '/src/views/**/*.vue',
  '/src/components/**/*.vue'
])

const normalizeViewPath = view => {
  if (!view) return ''
  return view
    .replace(/^@\/?/, '')
    .replace(/^src\//, '')
    .replace(/^\/+/, '')
    .replace(/\\/g, '/')
}

export const loadView = view => {
  const normalizedView = normalizeViewPath(view)
  if (!normalizedView) return undefined

  const candidates = [
    `/src/${normalizedView}`,
    `/src/${normalizedView}.vue`,
    `/src/${normalizedView}/index.vue`,
    `/src/${normalizedView}/Index.vue`
  ]

  const loader = candidates.map(path => viewModules[path]).find(Boolean)
  if (!loader) {
    console.warn(`[permission] route component not found: ${view}`, candidates)
    return undefined
  }
  return loader
}
